import { ExpandMore } from '@mui/icons-material'
import { Accordion, AccordionSummary, Box } from '@mui/material'
import PropTypes from 'prop-types'
import Badge from '../Badge/Badge'
import styles from './timelineStyle.js'
function Timeline(props) {
  const { stories, simple } = props
  return (
    <Box component="ul" sx={[styles.timeline, simple && styles.timelineSimple]}>
      {stories.map((prop, key) => {
        const isLast = key === stories.length - 1
        return (
          <Box
            component="li"
            sx={[styles.item, isLast && styles.noBefore]}
            key={key}
          >
            {prop.badgeIcon ? (
              <Box
                component={'div'}
                sx={[
                  styles.timelineBadge,
                  simple && styles.timelineSimpleBadge,
                  styles[prop.badgeColor],
                ]}
              >
                <prop.badgeIcon sx={[styles.badgeIcon]} />
              </Box>
            ) : null}
            <Box
              component={'div'}
              sx={[
                styles.timelinePanel,
                prop.inverted || (simple && styles.timelinePanelInverted),
                simple && styles.timelineSimplePanel,
              ]}
            >
              <Accordion
                defaultExpanded={prop.title !== 'System Update'}
                sx={{ border: 0, boxShadow: 0, paddingLeft: 0 }}
              >
                <AccordionSummary expandIcon={<ExpandMore />}>
                  {prop.title ? (
                    <Box component={'div'} sx={styles.timelineHeading}>
                      <Badge color={prop.titleColor}>{prop.title}</Badge>
                    </Box>
                  ) : null}
                </AccordionSummary>
                <Box component={'div'} sx={styles.timelineBody}>
                  {prop.body}
                </Box>
                {prop.footerTitle ? (
                  <Box component={'h6'} sx={styles.footerTitle}>
                    {prop.footerTitle}
                  </Box>
                ) : null}
                {prop.footer ? (
                  <Box component="hr" sx={styles.footerLine} />
                ) : null}
              </Accordion>
              {prop.footer ? (
                <Box component={'div'} sx={styles.timelineFooter}>
                  {prop.footer}
                </Box>
              ) : null}
            </Box>
          </Box>
        )
      })}
    </Box>
  )
}

export default Timeline

Timeline.propTypes = {
  stories: PropTypes.arrayOf(PropTypes.object).isRequired,
  simple: PropTypes.bool,
}
